import React, { ComponentProps } from 'react'
import { Image, ImageSourcePropType } from 'react-native'

import { Icon } from '@zet/design-system/icons'
import { XStack } from '@zet/design-system/layout'
import { B4 } from '@zet/design-system/typography'
import { LinearGradient } from 'expo-linear-gradient'

type TagProps = ComponentProps<typeof LinearGradient> & {
  infoIcon?: boolean
  icon: ImageSourcePropType | undefined
  title: string
}

const Tag = ({ infoIcon = false, colors, icon, title, ...props }: TagProps) => {
  return (
    <LinearGradient {...props} start={[0, 0.5]} end={[1, 1]} colors={colors}>
      <XStack className="items-center justify-between">
        <XStack className="  items-center px-2 py-1 ">
          <Image className=" h-[20] w-[20] " source={icon} />
          <B4 className=" text-grays-80 ml-2 ">{title}</B4>
        </XStack>

        {infoIcon && <Icon type="InfoOutlined" />}
      </XStack>
    </LinearGradient>
  )
}

export default Tag
